// HS Form Context
import * as React from 'react';

import { Sanitized } from '../@types/sanitized';
import { PromoTrackingData, PromoLandingPageForm } from '../@types/promoLandingPageData';
import { FormikProps } from 'formik';
import { BillingContext } from './BillingContext';
import { GenericContextHandlers } from './GenericContext';

export type BoostLeadsLandingPageContextHandlers = BillingContext &
    GenericContextHandlers & {
        contextType: 'boostLeadsLandingPage';
        brandingColor: string;
        clearInvalidInputError: () => void;
        customer: Sanitized.Customer;
        fbLeadId: string;
        formik: FormikProps<PromoLandingPageForm>;
        handleChange: () => void;
        inputError: string;
        invalidFormField: (formik: any) => boolean;
        isMarketReportForm: boolean;
        isSubmittingForm: boolean;
        namespace: string;
        pageNum: number;
        privacyPolicyUrl: string;
        setBackendSaysEmailInvalid: React.Dispatch<React.SetStateAction<boolean>>;
        setBackendSaysPhoneInvalid: React.Dispatch<React.SetStateAction<boolean>>;
        setInputError: React.Dispatch<React.SetStateAction<string>>;
        setIsSubmittingForm: React.Dispatch<React.SetStateAction<boolean>>;
        setPageNum: React.Dispatch<React.SetStateAction<number>>;
        termsOfUseUrl: string;
        trackingData: PromoTrackingData;
    };

const BoostLeadsLandingPageContext = React.createContext<
    Partial<BoostLeadsLandingPageContextHandlers>
>({});

export const useBoostLeadsLandingPageContext =
    (): Partial<BoostLeadsLandingPageContextHandlers> => {
        return React.useContext(BoostLeadsLandingPageContext);
    };

export default BoostLeadsLandingPageContext;
